module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":"classNames","commonjs2":"classnames","commonjs":"classnames","amd":"classnames"}
// module id = 2
// module chunks = 0